import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { ResponseModel, RESULT } from '../../model/response';
import { Stipulation } from '../../model/stipulation';
import useFetch from '../../hooks/useFetch';
import { stipulationSOCSelector } from '../../recoil/variableAtom';
import { cardTitleColor2 } from '../../styles/theme';

const ModalOverlay = styled.div`
  position: fixed;
  z-index: 1000;
  left: 0; top: 0; right: 0; bottom: 0;
  background: rgba(0,0,0,0.4);
  display: flex;
  align-items: center;
  justify-content: center;
`;

const ModalBox = styled.div`
  background: #fff;
  border-radius: 6px;
  padding: 36px 28px 28px 28px;
  width: 90%;
  max-width: 600px;
  max-height: 80vh;
  overflow-y: auto;
  box-shadow: 0 4px 16px rgba(0,0,0,0.10);
`;

const Title = styled.h2`
  font-size: 1.25rem;
  font-weight: 600;
  margin-bottom: 20px;
  text-align: center;
  color: ${cardTitleColor2};
`;

const Content = styled.div`
  font-size: 1rem;
  line-height: 1.6;
  color: #333;
  margin-bottom: 32px;
  white-space: pre-line;
`;

const CloseButton = styled.button`
  width: 100%;
  padding: 12px 0;
  background: #ff6900;
  color: #fff;
  font-size: 1rem;
  font-weight: 600;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  transition: background 0.15s;
  &:hover {
    background: #ff9a3c;
  }
`;

interface SocAgreementModalProps {
  open: boolean;
  onClose: () => void;
}

export default function SocAgreementModal({ open, onClose }: SocAgreementModalProps) {
  const [content, setContent] = useState<{ __html: string }>({ __html: '' });
  const response: ResponseModel<Stipulation> = useFetch({
    recoilSelector: stipulationSOCSelector,
  });
  useEffect(() => {
    if (response?.result === RESULT.FAIL) {
      alert("[페이지 오류 안내] 홈페이지 이용에 불편을 드려 죄송합니다. 새로고침 (F5키)을 누르시거나, 잠시 후에 이용해 주십시오.");
    } else {
      var res = response?.data?.cn;
      setContent({ __html: res || '' });
    }
  }, [response]);
  if (!open) return null;

  return (
    <ModalOverlay>
      <ModalBox>
        <Title>스마트충전기 배터리 정보 제3자 제공</Title>
        <Content dangerouslySetInnerHTML={content} />
        <CloseButton onClick={onClose}>확인</CloseButton>
      </ModalBox>
    </ModalOverlay>
  );
}
